<template>
    <div v-show="visible">
        <el-dialog title="预览报告" 
            element-loading-background = "rgba(255, 255,255,0.7)"
            :element-loading-text = "loadingText"
            v-loading="loading" 
            :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="1100px">    
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="form.name" placeholder="学生姓名"></el-input>
                </div>
            </div>
            &nbsp;
            <div style="display: inline-block; height:40px;">
                <el-button type="primary" icon="search" @click="getData()">查询</el-button>
            </div>

            <el-table
                :data="tempContent"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                height="600"
                border
                default-expand-all>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="name" label="学生姓名" width="80"></el-table-column>
                <el-table-column prop="className" label="班级名称" width="100"></el-table-column>
                <el-table-column prop="" label="评语" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        {{scope.row.comment}}
                        <!-- <div v-if="scope.row.commentSign == 1" style="color:red">
                            (系统自动生成)
                        </div> -->
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="130px" style="text-align:'left'">
                    <template slot-scope="scope">
                        <el-button style="color:#387EE8;"
                            @click.native.prevent="showData(scope.row.scoreReportUrl)"
                            type="text"
                            size="small">
                            学科成绩
                        </el-button>
                    
                        <el-button style="color:#387EE8;"
                            @click.native.prevent="showData(scope.row.reportUrl)"
                            type="text"
                            size="small">
                            素养报告
                        </el-button>
                    
                    </template>
                </el-table-column>
            </el-table>

            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="visible=false">关闭</el-button>
            </span>    
        </el-dialog>

        <!-- 编辑评语弹出框 -->
        <div v-if="updateVisible">
            <updateComment ref="updateComment"></updateComment>
        </div>

    </div>
</template>
       
<script>
    import http from '../../../common/http'; 
    import updateComment from './UpdateComment.vue';

    export default {
        data(){
            return{
                visible: false,
                updateVisible:false,
                form:{
                    name:"",
                },
                reportIdArr:"",
                tempContent:[],
                studencomprehensiveReport:{},
                
                loading:false,
                loadingText:"",

            }
        },
        components: {
            updateComment
        },
        created:function () {
        },
        mounted:function () {
        },
        methods:{
            indexMethod(index) {
                return index+1;
            },
            init(data){
                this.visible=true;
                this.form.reportIdArr=data.reportIdArr;
                this.studencomprehensiveReport=data;
                this.getData();
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            getData(){ // 查询
                let url  = this.tempStudencomprehensiveReportListUrl;
                let data = {
                    id:this.form.reportIdArr,
                    name:this.form.name
                };       
                // console.log(JSON.stringify(data))
                // return;
                this.loading=true;
                this.loadingText="加载中...";

                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.tempContent = res.data;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    this.loading=false;
                }); 
            },
            showData(url){
                window.open(url);
            },
            update(row){
                this.updateVisible=true;
                this.$nextTick(() => {
                    this.$refs['updateComment'].init(this.studencomprehensiveReport,row,1);
                })
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/complexReport/LookQualityReport.vue